<template>
  <div class="section-sponsors" id="section-sponsors" data-aos="fade-up" data-aos-once="true" data-aos-offset="-200">
    <div-container>

      <div class="columns is-gapless is-centered">
        <div class="column has-text-centered item-wrapper">
          <a href="/about">
            <h2 class="title">
              Official Partners
            </h2>
          </a>
        </div>
      </div>

      <div class="columns is-gapless is-centered is-vcentered is-flex-mobile is-multiline">
        <div v-for="mname in mnames" :key="mname" v-if="mitems[mname]" class="column is-3 is-6-mobile has-text-centered item-wrapper">
          <a v-if="mitems[mname].link" class="item" :href="mitems[mname].link" target="_blank">
            <img :src="mitems[mname].image.path" class="img-responsive" style="width:100%;max-width:160px;" nopin="nopin" />
          </a>
          <a v-else class="item" :href="'/about?anchor=' + mname">
            <img :src="mitems[mname].image.path" class="img-responsive" style="width:100%;max-width:160px;" nopin="nopin" />
          </a>
        </div>
      </div>

      <div class="columns is-gapless is-centered">
        <div class="column has-text-centered item-wrapper">
          <a href="/sponsors">
            <h2 class="title">
              Sponsors
            </h2>
          </a>
        </div>
      </div>

      <div class="columns is-gapless is-centered is-flex-mobile is-multiline">
        <div v-for="item in items" class="column is-3 is-6-mobile has-text-centered item-wrapper">
          <a class="item" :href="item.link" target="_blank">
            <img :src="item.image.path" class="img-responsive" />
          </a>
        </div>
      </div>

    </div-container>

    <div-container style="text-align:center;">
      <h4 class="button is-primary">
        <a href="/sponsors">View All</a>
      </h4>
    </div-container>

  </div>
</template>

<script>
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
// import ShowDown from 'showdown'

export default {
  name: 'section-sponsors',
  components: {
    DivContainer
  },
  data () {
    return {
      mnames: ['about-partner-1', 'about-partner-2', 'about-partner-3'],
      mitems: {},
      items: [],
      error: undefined,
      loading: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    getMainItem: function (mname, onComplete) {
      this.loading = true
      this.error = undefined
      Site.aboutWithName('bosshog::' + mname)
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        if (onComplete) {
          onComplete(mname, data)
        }
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    getItems: function (onComplete) {
      this.loading = true
      this.error = undefined
      Site.sponsor(1)
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        if (onComplete) {
          onComplete(data)
        }
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    refresh: function () {
      this.getItems((items) => {
        this.items = items
      })

      for (var i = 0; i < this.mnames.length; i++) {
        var mname = this.mnames[i]
        this.getMainItem(mname, (name, data) => {
          var params = {}
          if (data && data.image) {
            params.image = data.image
            params.link = data.link
          }
          this.$set(this.mitems, name, params)
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section sponsors

.section-sponsors {
  background-color: white;
  padding-top: 3rem;
  padding-bottom: 3rem;
  // background-image: url(../assets/menubg.jpg);
  // background-repeat: repeat-y;
  // background-position: center;
  // background-attachment: fixed;

  .columns.is-gapless > .column {
    padding: 10px;
  }

  .title {
    color: $color-darkbrown;
    font-family: $font-family-title;
    font-weight: bold;
    text-transform: uppercase;
  }

  .item-wrapper {

    a.item {
      display: inline-block;
      position: relative;

      img {
        width: 100%;
        // opacity: 0.6;
        // filter: alpha(opacity=60);
        transition: all .2s ease-in-out;
      }

      &:hover {
        img {
          // opacity: 1.0;
          // filter: alpha(opacity=100);
          transform: scale(1.1);
        }
      }
    }

    //   .banner-wrapper {
    //     position: absolute;
    //     bottom: 30px;
    //     width: 100%;
    //
    //     .banner {
    //       margin-left: 30px;
    //       margin-right: 30px;
    //       padding: 5px 15px;
    //       background-color: $color-orange;
    //       color: black;
    //       font-family: $font-family-title;
    //       font-weight: bold;
    //       font-size: 1.4em;
    //     }
    //   }
    // }
  }

  .view-all {
    a {
      color: $color-gray;
    }
    font-family: $font-family-title;
    text-transform: uppercase;
  }
}

</style>



// WEBPACK FOOTER //
// SponsorsSection.vue?5e9cc689